import React from 'react';

import PositionedGoodyHOC from '../PositionedGoodyHOC';
import { POSITIONED_GOODY_REFS } from '../../../../constants';

export default class Spinner extends PositionedGoodyHOC {
	// 11
	render() {
		const style = {
			st72: {
				fill: '#FFEAAE',
			},
			st20: {
				fill: '#75C69F',
			},
			st25: {
				fill: '#FC5959',
			},
			st50: {
				fill: '#238BD8',
			},
			st115: {
				fill: '#F2F2F2',
			},
		};
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="45.6753731" cy="60.6846466" />
				<path style={style.st72} d="M12.8749523,51.7303886c0,3.1619453,14.859787,5.7252083,33.4414062,5.7252083
					s32.4812698-2.5632629,32.4812698-5.7252083v-1.2722664c0-18.2690125-13.8996506-33.0789719-32.4812698-33.0789719
					S12.7731562,32.1891098,12.7731562,50.4581223L12.8749523,51.7303886z" />
				<path style={style.st20} d="M47.0884018,17.3790455c-19.3530293,0-34.9358139,14.8100643-34.9358139,33.0790787l0.1060219,1.2722664
					c0,2.1499062,1.9470673,3.3087311,12.6106405,4.287735C25.245472,34.0264244,31.6117287,20.7818718,47.0884018,17.3790455z" />
				<path style={style.st25} d="M45.7976303,17.3790455c19.875-0.1694336,34.9358063,14.8100643,34.9358063,33.0790787
					l-0.1060181,1.2722664c0,2.1499062-10.791214,4.0229225-21.4547882,5.0019264
					C58.7964096,34.7406158,55.67556,23.444231,45.7976303,17.3790455z" />
				<path style={style.st50} d="M71.8672943,55.0700951c1.1573486,0.0527344-3.9357529,2.8846321-16.569664,6.931263
					c-7.7006836,2.4665527-25.2500019-2.166748-34.25-2.666748S3.3689106,61.3919373,0.9468651,61.6978798
					c-0.6465269,0.081665-0.9431157-0.7743034-0.3897915-1.1185417l11.7015371-8.8489494
					c0,0,12.6187162-2.6598434,23.5390205-2.3957787C49.8369865,49.674099,71.8672943,55.0700951,71.8672943,55.0700951z" />
				<path style={style.st50} d="M46.2263412,18.8346119c-0.828125,0-1.5-0.6713867-1.5-1.5v-10c0-0.8286133,0.671875-1.5,1.5-1.5
					s1.5,0.6713867,1.5,1.5v10C47.7263412,18.1632252,47.0544662,18.8346119,46.2263412,18.8346119z" />
				<path style={style.st115} d="M73.7155533,7.3346114c0-3.8961933-3.5611725-7.0546818-11.5550842-7.0546818
					S44.7670288,7.3346114,44.7670288,7.3346114s9.3995247,7.0546813,17.3934402,7.0546813
					S73.7155533,11.2308044,73.7155533,7.3346114z" />
				<path style={style.st115} d="M18.7376862,7.3346114c0,3.896193,3.5611687,7.0546813,11.5550823,7.0546813
					s17.3934383-7.0546813,17.3934383-7.0546813s-9.3995247-7.0546818-17.3934383-7.0546818
					S18.7376862,3.4384181,18.7376862,7.3346114z" />
				<circle style={style.st50} cx="46.2266197" cy="7.3346114" r="3.5319245" />
			</g>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Hat/Spinner.js